module.exports = __webpack_public_path__ + "img/reset-password-mobile-ru.827bc982.jpg";